import { BadgeType } from '@@/Badge';

import { TrivySeverity } from './types';

const BADGE_TYPE: Record<TrivySeverity, BadgeType> = {
  CRITICAL: 'danger',
  HIGH: 'warn',
  MEDIUM: 'info',
  LOW: 'infoSecondary',
  UNKNOWN: 'muted',
  NONE: 'muted',
};

export function severityBadgeType(severity: TrivySeverity): BadgeType {
  return BADGE_TYPE[severity] ?? 'muted';
}
